import React, { useContext, useRef, useState } from "react";

import { ReactComponent as EyeClosed } from "../assets/icons/eye-closed.svg";
import { ReactComponent as Eye } from "../assets/icons/EyeOpen.svg";
import { ReactComponent as Copy } from "../assets/icons/copy.svg";
import { ReactComponent as CopyunSelect } from "../assets/icons/CopyunSelect.svg";

import { ReactComponent as CircleCross } from "../assets/icons/CircleCross.svg";
import { ReactComponent as CheckmarkСircleFill } from "../assets/icons/CheckmarkСircleFill.svg";
import { ReactComponent as ArrowDown } from "../assets/icons/chevron-down.svg";


import "./FormTextInput.css";
import { countiresDialInfo } from "../Data/countries-dial-info";
import { Search } from "react-feather";
import { NotificationContext } from "../Context/NotificationContext";

const NumberKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace"];

function FormTextInput({
  placeholder,
  value,
  onChange,
  color,
  correct,
  incorrect,
  password = false,
  email = false,
  disabled = false,
  focus = false,
  onKeyDown = () => { },
  width = "100%",
  showPasswordIcon = false,
  clearInputIcon = false,
  discountIcon = false,
  discountIconText = "",
  maxWidth = "100%",
  showCountryCode = false,
  onBlur,
  name,
  ref,
  copy = false,
  copyIcon = false,
  notAllow = false,
  type,
  autoComplete = "on",
  showBorderOnFocus = false,
  showBorderOnValue = false,
}) {
  const { showNotification } = useContext(NotificationContext);
  const [showPassword, setShowPassword] = useState(false);

  const [showCountryList, setShowCountryList] = useState(false);
  const searchRef1 = useRef(null);
  const [searchItem, setSearchItem] = useState("");
  const [countryCode, setCountryCode] = useState("US");
  const [dialCode, setDialCode] = useState("(+1) ");
  const inputRef = useRef();
  const [keyPress, setKeyPress] = useState(true);
  const [focused, setFocused] = useState(false);
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);


      setTimeout(() => setCopied(false), 3000);
      showNotification(value, "The coupon's has been successfully Copied.", "success");
    }
  };


  const handleInputChange = (e) => {
    if (showCountryCode) {
      if (e.target.value === "" || e.target.value.length < dialCode.length) {
        onChange(dialCode);
        return;
      }
      if (keyPress) {
        onChange(e.target.value, e.target.name);
      }
    } else {
      onChange(e.target.value, e.target.name);
    }
  }

  const handleKeyPress = (e) => {
    if (showCountryCode) {
      if ((e.key === "Backspace" && e.target.value === dialCode) || !NumberKeys.includes(e.key)
        || (e.key !== "Backspace" && e.target.value.length >= 17)) {
        setKeyPress(false);
      } else {
        setKeyPress(true);
      }
    }

    onKeyDown(e);

  }

  return (
    <div className={`formInputSimpleContainer ${showCountryCode && "formMobileInputWrap"} `} style={{
      width: width, maxWidth: maxWidth, borderColor: !focused && incorrect
        ? "#D70015"
        : correct
          ? "#eff0f2"
          : color || "#eff0f2",
    }}>

      {showCountryCode && <div className="formCountrySelector" onClick={() => setShowCountryList(i => !i)}>
        <img className="inputCountryImage" src={`/flags/${countryCode}.svg`} alt="us" />
        <ArrowDown className="inputCountryIcon" />

      </div>}
      {showCountryCode && showCountryList &&
        <div className="translationLanguageOptions">
          <div className="languageSearchForm">
            <input
              value={searchItem}
              autoFocus
              onChange={(e) => setSearchItem(e.target.value)}
              placeholder="Search"
              className="languageSearchFormsInput"
              ref={searchRef1}
            />
            <Search className="languageSearchFormIcon" />
          </div>
          <div className="countryListContainer" id="searchCountryContainer">
            {
              countiresDialInfo.filter(item => item.name.toLowerCase().includes(searchItem.toLowerCase())).map((item, i) => (
                <div key={i} className={`languageWrapper countryLanguageWrapper`} onClick={() => {
                  setCountryCode(item.code);
                  setDialCode(`(${item.dial_code})${" "}`);
                  onChange(`(${item.dial_code})${" "}`)
                  setShowCountryList(false);
                }}>
                  <div className="languageWrapper">
                    <img className="inputCountryImage" src={`/flags/${item.code}.svg`} alt={item.flag} />
                    <div
                      key={item.name}
                      className={
                        item.dial_code === value
                          ? "translationLanguageOption highlighted"
                          : "translationLanguageOption"
                      }
                    >
                      {item.name}
                    </div>
                  </div>
                  <div className="countryDialCode">
                    {item.dial_code}
                  </div>
                </div>
              ))

            }
          </div>
        </div>}
      <input
        name={name}
        style={{ width: (clearInputIcon && incorrect) || (password && showPasswordIcon) ? "90%" : discountIcon ? "85%" : "100%" }}
        autoFocus={focus}
        onFocus={() => setFocused(true)}
        onBlur={() => { setFocused(false); onBlur && onBlur(); }}
        onKeyDown={handleKeyPress}
        ref={inputRef}
        disabled={disabled}
        type={type ? type : password ? (showPassword ? "text" : "password") : (email ? "email" : "text")}
        className={`formInputSimple countryInputField ${notAllow && "cursor-not-allowed"} ${value !== "" && "validInput"} ${showBorderOnFocus && (focused ) && "border-[#021023] border-[1px]"}`}
        placeholder=""
        value={value}
        onChange={handleInputChange}
        autoComplete={autoComplete}
      />
      <p
        className={`formInputSimpleLabel ${
          (value !== "" || focused) ? "validInputLabel" : ""
        } ${showCountryCode && "formMobileLabel"}`}
      >
        {placeholder}
      </p>



      {!showCountryCode ? (
        password && showPasswordIcon ? (
          showPassword ? (
            <Eye className="formPasswordEyeIcon" onClick={() => setShowPassword(false)} />
          ) : (
            <EyeClosed className="formPasswordEyeIcon" onClick={() => setShowPassword(true)} />
          )
        ) : clearInputIcon && incorrect ? (
          <CircleCross
            className="formPasswordEyeIcon"
            onClick={() => {
              onChange("", name); // Clear the value
              inputRef.current.value = ""; // Reset the input field visually
            }}
          />
        ) : (
          discountIcon && (
            <div className="dicountIconWrapper">
              <p className="discountIconText">{discountIconText}</p>
              <CheckmarkСircleFill className="discountIcon" />
            </div>
          )
        )
      ) : null}

      {!showCountryCode ? (
        copy ? (
          copied ? (
            <Copy className="copySelectIcon" />
          ) : (
            <CopyunSelect className="copySelectIcon" onClick={handleCopy} />
          )
        ) : null
      ) : null}

    </div>
  );
}

export { FormTextInput };
